/**
 * @since 2.0.0
 */
const globalStoreId = /*#__PURE__*/Symbol.for("effect/GlobalValue/globalStoreId");
if (!(globalStoreId in globalThis)) {
  globalThis[globalStoreId] = /*#__PURE__*/new Map();
}
const globalStore = globalThis[globalStoreId];

/**
 * @since 2.0.0
 */
const globalValue = (id, compute) => {
  if (!globalStore.has(id)) {
    globalStore.set(id, compute());
  }
  return globalStore.get(id);
};

export { globalValue };
